import { Slider as MuiSlider } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';

import { colorUsage, getSpacing, fontSize } from 'stylesheetB2c';

export const CastingControlBarContainer = styled.div`
  height: ${getSpacing(9)};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colorUsage.infoGrey};
  color: ${colorUsage.whiteText};
  padding: 0 ${getSpacing(3)};
  flex-shrink: 0;
`;
CastingControlBarContainer.displayName = 'CastingControlBarContainer';

export const SongTitle = styled.span`
  font-size: ${fontSize.small};
  margin-bottom: ${getSpacing(1)};
  text-overflow: ellipsis;
  overflow: hidden;
`;
SongTitle.displayName = 'SongTitle';

export const SongArtist = styled.span`
  font-size: ${fontSize.XSmall};
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
`;
SongArtist.displayName = 'SongArtist';

export const SongInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${getSpacing(5)};
  white-space: nowrap;
  width: 30%;
`;
SongInfo.displayName = 'SongInfo';

export const Slider = muiStyled(MuiSlider)(() => ({
  marginRight: getSpacing(5),
}));
